<template>
  <v-app>
    <v-toolbar color="grey lighten-4"
               fixed
               app>
      <v-spacer>
      </v-spacer>
      <change-language-dropdown :show-flag-country="true"></change-language-dropdown>
    </v-toolbar>

    <v-content>
      <v-container>
        <v-layout justify-center>
          <v-flex text-xs-center>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-snackbar :timeout="snackbar.timeout"
                :right="snackbar.right"
                :top="snackbar.top"
                v-model="snackbar.visible"
                :color="snackbar.color">
      {{ snackbar.text }}
      <v-btn dark
             flat
             @click.native="visible = false">X</v-btn>
    </v-snackbar>

    <dps-footer></dps-footer>
  </v-app>
</template>
<script>
import ChangeLanguageDropdown from '@/components/commons/ChangeLanguageDropdown.vue';
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import DpsFooter from '@/components/commons/Footer';

export default {
  name: 'login-layout',
  components: {
    [ChangeLanguageDropdown.name]: ChangeLanguageDropdown,
    [DpsFooter.name]: DpsFooter
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.isLogged) {
      next('/dashboard');
      return;
    }
    next();
  },
  created() {
    EventBus.$on(keys.eventOnShowNotification, this.showNotification);
  },
  destroyed() {
    EventBus.$off(keys.eventOnShowNotification, this.showNotification);
  },
  data() {
    return {
      snackbar: {
        text: '',
        visible: false,
        timeout: 3000,
        right: true,
        top: true
      }
    };
  },
  methods: {
    showNotification(data) {
      if (data.doNotTranslate) {
        this.snackbar.text = data.message;
      } else {
        this.snackbar.text = this.$i18n.t(data.message, data.messageParams);
      }
      this.snackbar.color = data.type;
      this.snackbar.visible = true;
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/sass/dps-customization.scss';
</style>



// WEBPACK FOOTER //
// src/components/layouts/LoginLayout.vue